import strings from 'owa-strings/owa-common-strings';

export default function() {
    return [
        {
            label: strings.peopleFeedbackCheckboxNoResult,
            name: 'noResult',
        },
        {
            label: strings.peopleFeedbackCheckboxSearchSlow,
            name: 'searchSlow',
        },
        {
            label: strings.peopleFeedbackCheckboxResultNotRelevent,
            name: 'resultNotRelevent',
        },
        {
            label: strings.peopleFeedbackCheckboxItemNotInResult,
            name: 'itemNotInResult',
        },
        {
            label: strings.peopleFeedbackCheckboxSugNotUseful,
            name: 'sugNotUseful',
        },
        {
            label: strings.peopleFeedbackCheckboxHardToUse,
            name: 'hardToUse',
        },
        {
            label: strings.peopleFeedbackCheckboxOther,
            name: 'other',
        },
    ];
}
